export const gameTypes = [
  {
    type: "Action",
    subTypes: ["Shooter", "Platformer", "Fighting", "Beat 'Em Up"],
  },
  {
    type: "Adventure",
    subTypes: ["Point-and-Click", "Narrative-Driven", "Metroidvania"],
  },
  {
    type: "Role-Playing Game (RPG)",
    subTypes: ["Action RPG", "Turn-Based RPG", "MMORPG", "Tactical RPG"],
  },
  {
    type: "Simulation",
    subTypes: [
      "Life Simulation",
      "City/World Building",
      "Farming",
      "Flight Simulation",
      "Business Simulation",
    ],
  },
  {
    type: "Strategy",
    subTypes: [
      "Real-Time Strategy (RTS)",
      "Turn-Based Strategy",
      "Tower Defense",
      "4X (Explore, Expand, Exploit, Exterminate)",
    ],
  },
  {
    type: "Sports and Racing",
    subTypes: ["Sports", "Racing", "Extreme Sports"],
  },
  {
    type: "Puzzle",
    subTypes: ["Logic-Based", "Physics-Based", "Match-Three"],
  },
  {
    type: "Party and Casual",
    subTypes: ["Party Games", "Trivia", "Rhythm"],
  },
  {
    type: "Horror",
    subTypes: ["Survival Horror", "Psychological Horror", "Multiplayer Horror"],
  },
  {
    type: "Sandbox/Open World",
    subTypes: ["Creative Sandbox", "Open World Exploration"],
  },
  {
    type: "Multiplayer",
    subTypes: ["Battle Royale", "MOBA", "Co-op Multiplayer"],
  },
];

export const dimensions = [
  "320x240",
  "480x320",
  "640x480",
  "800x480",
  "800x600",
  "1024x768",
  "1280x720",
  "1366x768",
  "1920x1080",
  "1920x1200",
  "2048x1536",
  "2160x1200",
  "2340x1080",
  "2360x1640",
  "2560x1080",
  "2560x1440",
  "2560x1600",
  "2732x2048",
  "2880x1600",
  "2960x1440",
  "3200x1440",
  "3440x1440",
  "3840x1080",
  "3840x2160",
  "4320x2160",
  "5120x1440",
  "5120x2160",
  "7680x4320",
];

export const ageGroupList = [
  { value: "All", label: "All Ages" },
  { value: "Children", label: "Children" },
  { value: "Preteens", label: "Preteens" },
  { value: "Teens/Adolescents", label: "Teens/Adolescents" },
  { value: "Young Adults", label: "Young Adults" },
  { value: "Adults", label: "Adults" },
  { value: "Middle-Aged Adults", label: "Middle-Aged Adults" },
  { value: "Seniors", label: "Seniors" },
  { value: "Elderly", label: "Elderly" },
  { value: "Young Seniors", label: "Young Seniors" },
  { value: "Mature Adults", label: "Mature Adults" },
];
export const genderList = [
  { value: "male", label: "male" },
  { value: "female", label: "female" },
];
export const foucusedAreasData = [
  { value: "Sustainability", label: "Sustainability" },
  { value: "Child Welfare", label: "Child Welfare" },
  { value: "Poverty Alleviation", label: "Poverty Alleviation" },
  { value: "Climate Change Awareness", label: "Climate Change Awareness" },
  { value: "Environmental Protection", label: "Environmental Protection" },
  { value: "Education", label: "Education" },
  { value: "Community Development", label: "Community Development" },
  { value: "Leadership", label: "Leadership" },
  { value: "Water Access", label: "Water Access" },
  { value: "Sanitation", label: "Sanitation" },
  { value: "Health", label: "Health" },
];

export const adsTypes = [
  { value: "Image, Rich Media", label: "Image, Rich Media" },
  { value: "Image, HTML, Rich Media", label: "Image, HTML, Rich Media" },
  { value: "Image, Video, Rich Media", label: "Image, Video, Rich Media" },
  { value: "Video, Interactive", label: "Video, Interactive" },
  { value: "Image, Text, Rich Media", label: "Image, Text, Rich Media" },
  { value: "Video", label: "Video" },
  { value: "Image, Rich Media", label: "Image, Rich Media" },
];

export const adFormats = [
  { value: "App Open", label: "App Open" },
  { value: "Banner", label: "Banner" },
  { value: "Interstitial", label: "Interstitial" },
  { value: "Native Advanced", label: "Native Advanced" },
  { value: "Rewarded", label: "Rewarded" },
  { value: "In-page Push", label: "In-page Push" },
  { value: "Video Slider", label: "Video Slider" },
  {
    value: "VAST (Video Ad Serving Template)",
    label: "VAST (Video Ad Serving Template)",
  },
  { value: "Sticky / Floating Banner", label: "Sticky / Floating Banner" },
];

export const badgesDuration = ["weekly", "monthly", "permanent"];
export const badgesReqValues = {
  weekly: ["20", "50", "100", "150", "200", "250", "300", "350", "400"],
  monthly: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  permanent: [
    "250",
    "500",
    "750",
    "1000",
    "2000",
    "3000",
    "4000",
    "5000",
    "7500",
    "10000",
  ],
};
